module.exports = __webpack_public_path__ + "static/media/social-media-icons-03@2x.d53cfba6.png";